<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>基础数据</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path: '/college/list'}">院校管理</el-breadcrumb-item>
        <el-breadcrumb-item>学院管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">学院管理</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleAcademyCreate"
          >添加学院</el-button>
        </div>
      </div>
    </div>
    <div class="info card">
      <div class="info-item">
        <span class="label">院校名称：</span>
        <span class="value">{{college.name}}</span>
      </div>
      <el-divider
        class="divider"
        direction="vertical"
      ></el-divider>
      <div class="info-item">
        <span class="label">院校代码：</span>
        <span class="value">{{college.code}}</span>
      </div>
      <el-divider
        class="divider"
        direction="vertical"
      ></el-divider>
      <div class="info-item">
        <span class="label">院校地区：</span>
        <span class="value">{{college.province_name}}</span>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="学院名称"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="code"
            label="学院代码"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="sort"
            label="排序值"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="状态"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1?'success':'danger'">{{scope.row.status == 1 ? '正常' : '下线'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="140"
            align="center"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToAcademyEdit(scope.row, scope.$index)"
              >编辑</el-button>
              <el-button
                size="mini"
                type="text"
                @click="handleToMajor(scope.row, scope.$index)"
              >专业列表</el-button>
              <!-- <el-button
                class="remove-text-button"
                size="mini"
                type="text"
                @click="handleToAcademyRemove(scope.row, scope.$index)">删除</el-button> -->
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToAcademyEdit(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="c"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToMajor(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      专业列表
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <AcademyCreate
      :visible="createDialog"
      :college="college"
      @close="createDialog = false"
      @submit="fetchAcademyList"
    ></AcademyCreate>
    <AcademyEdit
      :visible="editDialog"
      :content="editRow"
      :college="college"
      @close="editDialog = false"
      @submit="fetchAcademyList"
    ></AcademyEdit>
  </div>
</template>

<script>
import AcademyCreate from '@/components/dialog/college/AcademyCreate'
import AcademyEdit from '@/components/dialog/college/AcademyEdit'
import { academyList, collegeOne, academyDestroy } from '@/api/common'

export default {
  components: {
    AcademyCreate,
    AcademyEdit
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      editRow: {},
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      pageTotal: 10,
      college: {},
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
    }
  },
  created() {
    this.parseQuery()
    this.fetchCollegeInfo()
  },
  methods: {
    fetchCollegeInfo() {
      collegeOne({ id: this.$route.params.collegeId }).then(res => {
        this.college = res

        this.fetchAcademyList()
      })
    },
    // 学院列表请求
    fetchAcademyList() {
      let params = { ...this.query }
      params.college_code = this.college.code
      academyList(params).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchAcademyList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchAcademyList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchAcademyList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchAcademyList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        '1': '正常',
        '2': '关闭'
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    // 学院创建
    handleAcademyCreate() {
      this.createDialog = true
    },
    // 学院编辑
    handleToAcademyEdit(row) {
      this.editRow = Object.assign({}, row, { status: row.status == 1 ? true : false })
      this.editDialog = true
    },
    // 学院删除
    handleToAcademyRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        academyDestroy({ id: row.id }).then(res => {
          this.$message.success(`删除成功`)
          this.fetchAcademyList()
        })
      }).catch(() => { })
    },
    // 学院专业列表
    handleToMajor(row) {
      this.$router.push(`/college/${this.college.id}/academy/${row.id}/major`)
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach(key => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(key => this.$route.query[key] != this.query[key])
      isSync && this.$router.replace({
        query: Object.assign({}, this.$route.query, this.query)
      })
    },
  }
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .info {
    display: flex;
    margin-top: 10px;

    .info-item {
      .label {
        color: #909399;
      }
      .value {
        // margin-left: 5px;
      }
    }
    .divider {
      margin: 0 20px;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
